import router from '@/router'
import { runOnboarding, stopOnboarding } from './engine'
import { contactSteps } from './contact.onboarding'
import { contactFormSteps } from './contact-form.onboarding'
import { movieSteps } from './movie.onboarding'
import { getMovieFormSteps } from './movie-form.onboarding'
import {
  getNextOnboardingDemoStepId,
  hasOnboardingDemoProgress,
  isOnboardingDemoEnabled,
  resetOnboardingDemoProgress,
  setOnboardingDemoEnabled,
} from './state'

export function startContactOnboarding() {
  return runOnboarding(contactSteps)
}

export function startContactFormOnboarding() {
  return runOnboarding(contactFormSteps)
}

export function startMovieOnboarding() {
  return runOnboarding(movieSteps)
}

export function startMovieFormOnboarding(vm) {
  return runOnboarding(getMovieFormSteps(vm))
}

function isNewContactRoute(route) {
  return route && route.name === 'contacts-form' && route.params && route.params.contact_id === 'new'
}

function isNewMovieRoute(route) {
  return route && route.name === 'movies-form' && route.params && route.params.movie_id === 'new'
}

function getRouteForDemoStep(stepId) {
  switch (stepId) {
    case 'contacts-dashboard':
      return { name: 'contacts' }
    case 'contact-form':
      return { name: 'contacts-form', params: { contact_id: 'new' } }
    case 'movies-list':
      return { name: 'movies' }
    case 'movie-form':
      return { name: 'movies-form', params: { movie_id: 'new' } }
    default:
      return { name: 'contacts' }
  }
}

function matchesRouteForDemoStep(route, stepId) {
  switch (stepId) {
    case 'contacts-dashboard':
      return route && route.name === 'contacts'
    case 'contact-form':
      return isNewContactRoute(route)
    case 'movies-list':
      return route && route.name === 'movies'
    case 'movie-form':
      return isNewMovieRoute(route)
    default:
      return false
  }
}

function startDemoStep(stepId, vm) {
  switch (stepId) {
    case 'contacts-dashboard':
      return startContactOnboarding()
    case 'contact-form':
      return startContactFormOnboarding()
    case 'movies-list':
      return startMovieOnboarding()
    case 'movie-form':
      return startMovieFormOnboarding(vm)
    default:
      return false
  }
}

export function maybeStartOnboardingForRoute(vm) {
  if (!isOnboardingDemoEnabled()) {
    return false
  }

  const stepId = getNextOnboardingDemoStepId()
  const route = (vm && vm.$route) || router.currentRoute

  if (!stepId || !matchesRouteForDemoStep(route, stepId)) {
    return false
  }

  return startDemoStep(stepId, vm)
}

export function startOrResumeOnboardingDemo(vm) {
  sessionStorage.clear()
  setOnboardingDemoEnabled(true)

  let stepId = getNextOnboardingDemoStepId()

  if (!stepId) {
    resetOnboardingDemoProgress()
    stepId = getNextOnboardingDemoStepId() || 'contacts-dashboard'
  }

  const route = (vm && vm.$route) || router.currentRoute
  if (matchesRouteForDemoStep(route, stepId)) {
    return startDemoStep(stepId, vm)
  }

  router.push(getRouteForDemoStep(stepId)).catch(() => {})
  return true
}

export function stopOnboardingDemo() {
  setOnboardingDemoEnabled(false)
  stopOnboarding()
  sessionStorage.clear()
}

export function getOnboardingDemoButtonLabel() {
  if (isOnboardingDemoEnabled()) {
    return 'Stop Demo'
  }

  if (hasOnboardingDemoProgress()) {
    return 'Resume Demo'
  }

  return 'Start Demo'
}
